import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";
import { inlineIconGlyphSize, inlineIconSize } from "@common/inlineIconSizes";

const removeItemClass = "dotlegal-removable-item-remove";
const borderColor = "rgba(0, 0, 0, 0.08)";
const boxBorderRadius = 10;

export const useDotLegalRemovableItemsStyles = () => {
    const theme = useTheme();

    return createSxStyles({
        // The box carries no padding of its own, so each item reaches its edges and stays hoverable all the way out
        // to the border. The items draw the lines between them instead of a divider, which keeps them edge to edge.
        container: {
            marginBottom: theme.spacing(2),
            border: `1px solid ${borderColor}`,
            borderRadius: `${boxBorderRadius}px`,
        },
        item: {
            position: "relative",
            padding: theme.spacing(2),
            "&:not(:first-of-type)": {
                borderTop: `1px solid ${borderColor}`,
            },
            "&:first-of-type": {
                borderTopLeftRadius: `${boxBorderRadius}px`,
                borderTopRightRadius: `${boxBorderRadius}px`,
            },
            "&:last-of-type": {
                borderBottomLeftRadius: `${boxBorderRadius}px`,
                borderBottomRightRadius: `${boxBorderRadius}px`,
            },
            [`&:hover .${removeItemClass}, &:focus-within .${removeItemClass}`]: {
                opacity: 1,
            },
        },
        // The fields render after the icon and set position themselves, so without a stacking order of its own the
        // icon ends up painted underneath them and cannot be clicked. The wrapper carries the position rather than the
        // button, so the tooltip still has something to listen on while the button is disabled.
        removeItemContainer: {
            position: "absolute",
            zIndex: 1,
            top: theme.spacing(1),
            right: theme.spacing(1),
            display: "inline-flex",
        },
        // Sized to the icon a field renders inside itself, so the remove icon does not outweigh the fields it sits above
        removeItem: {
            opacity: 0,
            transition: theme.transitions.create("opacity"),
            padding: 0,
            width: inlineIconSize,
            height: inlineIconSize,
            "& svg": {
                width: inlineIconGlyphSize,
                height: inlineIconGlyphSize,
            },
        },
    });
};

export { removeItemClass };
